import {defaultFetch} from "@/scripts/Common/api";
import {ref} from "vue";
import {AvailableCardRanges} from "@/components/cards/scripts";

export const fetchAvailableCardRanges = async (apiName: string, token: string) => {

  const cardRanges = ref<AvailableCardRanges[]>([]);

  const {
    error,
    response,
  } = await defaultFetch({
    // @ts-ignore
    apiName: apiName,
    bearer: token
  });

  if(response){
    cardRanges.value = response;
  }

  return { error, cardRanges };
};
